import CircularProgress from '@mui/material/CircularProgress';
import { clsx } from 'clsx';
import React from 'react';

import { TESTID } from 'configs/Constant';

import useStyles from './styles';

const Loading = ({ loadingStyle }) => {
  const classes = useStyles();

  return (
    <div
      className={clsx(classes.wrap, loadingStyle)}
      testid={TESTID.WRAP_LOADING}
    >
      <CircularProgress />
    </div>
  );
};

export default Loading;
